// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import { productListFilterAccordionSectionStyles } from "@west/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import Minus from "@west/XDL/Icons/Minus";
import Plus from "@west/XDL/Icons/Plus";
import Search from "@west/XDL/Icons/Search";
import { color, styledScrollbar } from "@west/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    expandIconProps: {
        src: ChevronDown,
        size: 12,
    },
    collapseIconProps: {
        src: ChevronUp,
        size: 12,
    },
    titleTypographyProps: {
        size: 12,
        weight: "bold",
        lineHeight: "14px",
    },
    panelProps: {
        css: css`
            border: none;
            padding: 6px 9px 9px;
        `,
    },
    headerProps: {
        css: css`
            border-top: 1px solid ${color("common.border")};
            &&& button,
            &&& button:focus {
                margin-bottom: 0;
                padding: 8px;
                border: none;
            }
        `,
    },
};

productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        width: 100%;
        span[role="checkbox"] {
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 4px;
                      `}
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-word;
            display: flex;
            width: 100%;
        `,
    },
};

productListFilterAccordionSectionStyles.facetCount = {
    color: "text.main",
    css: css`
        margin-left: auto;
        padding-left: 2px;
        flex-shrink: 0;
    `,
};

productListFilterAccordionSectionStyles.seeAllLink = {
    icon: {
        iconProps: {
            src: Plus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
};

productListFilterAccordionSectionStyles.seeLessLink = {
    icon: {
        iconProps: {
            src: Minus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
};

productListFilterAccordionSectionStyles.facetFilterTextField = {
    mergeCss: true,
    sizeVariant: "default",
    iconProps: {
        src: Search,
        color: "common.ui8",
    },
    border: "rectangle",
};

productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        ${({ filterable }: any) =>
            filterable &&
            css`
                margin-top: 12px;
            `}
        ${({ scrollable, limitNumber }: any) =>
            scrollable &&
            css`
                max-height: calc(${limitNumber * 26}px - 8px);
                padding-right: 12px;
                ${styledScrollbar()};
            `}
    `,
};
